import { Link } from "wouter";
import { SEOHead } from "../components/SEOHead";
import { FooterPixCapture } from "../components/FooterPixCapture";
import { ArrowLeft, Building2 } from "lucide-react";

export default function PixCaptureImpressum() {
  return (
    <div className="min-h-screen bg-[var(--color-white)] flex flex-col">
      <SEOHead
        title="Impressum – pixcapture.app"
        description="Impressum und Kontaktdaten von pixcapture.app"
        path="/impressum"
      />

      <header className="border-b border-[var(--color-light-grey)]">
        <div className="max-w-[1200px] mx-auto px-8 py-6">
          <div className="flex items-center gap-4">
            <Link href="/">
              <button className="hover:bg-gray-100 p-2 rounded">
                <ArrowLeft className="h-5 w-5" />
              </button>
            </Link>
            <Building2 className="h-6 w-6 text-[var(--color-accent)]" />
            <h1 className="text-[24px] font-medium tracking-[0.05em] text-[var(--color-black)] leading-none">
              Impressum
            </h1>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-[800px] mx-auto px-8 py-16">
          <div className="space-y-8">
            <section>
              <h2 className="mb-4">Angaben gemäß § 5 TMG</h2>
              <div className="text-[var(--color-grey)]">
                <p>pixcapture.app</p>
                <p>Ein Service von PIX.IMMO</p>
                <p className="mt-4">Hamburg, Deutschland</p>
              </div>
            </section>

            <section>
              <h2 className="mb-4">Kontakt</h2>
              <div className="text-[var(--color-grey)]">
                <p>E-Mail: <a href="mailto:info@pixcapture.app" className="text-[var(--color-accent)]">info@pixcapture.app</a></p>
                <p>Website: <a href="https://pixcapture.app" className="text-[var(--color-accent)]">pixcapture.app</a></p>
              </div>
            </section>

            <section>
              <h2 className="mb-4">Verantwortlich für den Inhalt</h2>
              <div className="text-[var(--color-grey)]">
                <p>Angaben gemäß § 55 Abs. 2 RStV</p>
                <p className="mt-2">pixcapture.app Team</p>
              </div>
            </section>

            <section>
              <h2 className="mb-4">EU-Streitschlichtung</h2>
              <div className="text-[var(--color-grey)]">
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                </p>
                <a 
                  href="https://ec.europa.eu/consumers/odr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[var(--color-accent)]"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </div>
            </section>

            <section>
              <h2 className="mb-4">Verbraucherstreitbeilegung</h2>
              <div className="text-[var(--color-grey)]">
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <FooterPixCapture />
    </div>
  );
}
